import { MfaChallengeResponse } from '~services/authentication/types';

export const isMfaChallengeResponse = (response: unknown): response is MfaChallengeResponse => {
    return (response as MfaChallengeResponse)?.type === 'MFA';
};
